// @flow
import * as materialAppearance from './material'

// Types
import type { Styles } from '..'

// Container for the input
export const Container = ({ $disabled, $palette }: Styles) => ({
  fontSize: '16px',
  display: 'block',
  position: 'relative',
  padding: '7px 10px',
  boxSizing: 'border-box',
  width: '100%',
  pointerEvents: $disabled ? 'none' : 'initial',
  opacity: $disabled ? 0.5 : 1,
  background: `${$palette('gray').lighten(8)}`,
})

// The line above the input
export const Baseline = {
  display: 'none',
}

// The input element
export const InputWrapper = ({ $palette }: Styles) => ({
  maxWidth: '100%',
  color: `${$palette('text')}`,
  display: 'flex',
  lineHeight: '1.1875em',
  padding: '0 7px',
  flexFlow: 'row nowrap',
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0,
  alignItems: 'center',
})

// A small wrapper around content - input and label
export const Content = ({ $invalid, $palette }: Styles) => ({
  position: 'relative',
  background: `${$palette('gray')}`,
  borderRadius: '5px',
  boxShadow: $invalid ? `0 0 1px 1px ${$palette('red')}` : 'none',
})

// Float label element
export const Label = {
  display: 'none',
}

// Errors container
export const Errors = {
  display: 'none',
}

// Button to clear the input
export const ClearButton = (props: Styles) => ({
  ...materialAppearance.ClearButton(props),
  color: `${props.$palette('gray').darken(20)}`,
})

// Wrapper for the content before the input
export const PrefixWrapper = () => ({
  marginRight: '8px',
  flexShrink: 0,
})

export const PostfixWrapper = {
  ...materialAppearance.PostfixWrapper,
  marginRight: 0,
}
